import React, { useState } from 'react';
import axios from 'axios';
import { useWorkspace } from '../../../context/WorkspaceContext'; // Import useWorkspace

const BACKEND_API_URL = process.env.REACT_APP_BACKEND_API_URL;

const YoutubeLoginButton = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { idToken } = useWorkspace(); // Access idToken

  const handleAuthClick = () => {
    if (!idToken) {
      console.error('idToken is not set');
      return;
    }

    setIsLoading(true);
    axios.get(BACKEND_API_URL + '/api/google/oauth', {
      headers: { Authorization: `Bearer ${idToken}` }
    })
      .then(response => {
        // Set pending auth flag
        localStorage.setItem('social_auth_pending', 'youtube');
        window.open(response.data, '_blank');
        setIsLoading(false);
      })
      .catch(error => {
        console.log(error);
        setIsLoading(false);
      });
  };
  return (
    <button className="flex items-center w-full justify-between  h-[70px] p-4 bg-red-600 !text-white rounded-lg" onClick={handleAuthClick} disabled={isLoading}>
      {isLoading ? 'Loading...' : (
        <>
          <div className="mr-3 w-12 h-12 bg-white rounded-full flex items-center justify-center">
            <img
              src={'../socials/youtube-logo.svg'}
              alt="Instagram Logo"
              className="w-8 h-8"
            />
          </div>
            {'Youtube'}
        </>
      )}
      <div></div>
    </button>
  );
}

export default YoutubeLoginButton;